<app-header></app-header>
<main>
  <div class="container below_header" style="font-size:13px;">    
    <div class="row">
      <div class="col-lg-12 col-md-12 col-xs-12">          
        <div>         
          <i class="fa fa-file-text-o invoice_icon"></i>
          <span class="invoice_id"><b>Invoice ID(s) : </b>            
          </span>
          <span class="invoice_textarea">
              <textarea pInputTextarea [(ngModel)]="selectedInvoiceIDs" readonly="true"
              rows="5" cols="100" 
              class="invoice_textarea_body" readonly></textarea>               
          </span>                                                   
        </div>
        <div class="detail_list">
          <span class="col-xs-12 col-lg-3 col-md-3"><b style="padding-left: 15px;">Agency </b> <b style="padding-left:75px;padding-right:inherit;"> : </b> {{agencyID}}</span>
          
        </div>
        <div class="payment_detail_main">
          <i class="fa fa-credit-card payment_detail_icon"></i>
          <span class="payment_detailtxt">Payment Details</span>
          <div class="ui-g" style="width:250px;margin-bottom:30px">
            <div class="ui-g-12">
              <table>
                <tr>
                  <td>
                    <input type="radio" name="group1" value="FullPayment1" class="checkbox_modified" (change)="onRadioACHChecked($event)" checked>Pay via ACH
                  </td>
                  <td>
                    <input type="radio" name="group1" value="FullPayment2" class="checkbox_modified" (change)="onRadioCCChecked($event)">Pay via Amex
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="checkbox checkbox_main">
             <input type="checkbox" [disabled]="isSelectedMultipleInovice" value="FullPayment" class="checkbox_modified"  checked   (change)="onChecked($event)">
            <span class="full_payment"> Full Payment</span>
            <span class="input_number">
              <input currencyMask type="text" on-paste="false" [disabled]="isPayment" 
              class="input_numberinput" [(ngModel)]="totalamount" 
              pKeyFilter="money" maxlength="20" prefix="$" currency="USD">
            </span><!--(blur)="reCalculate($event,OrderagencyID, paymenttype)"-->
            <button type="button" class="btn recalc_modifi" [disabled]="isChecked" (click)="reCalculate($event,agencyID, paymenttype)">Recalculate</button>
            <!-- <span [hidden]="!InvalidAmount" class="input-ErrorField" >Please enter the amount less than Invoice amount. </span>-->
			<span [hidden]="!InvalidAmount" class="input-ErrorField" >Please enter an amount less than Gross Cash Discount Price. </span>
             <span [hidden]="!InvalidAmount2" class="input-ErrorField" >Please enter the amount greater than 0. </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-5 col-md-5 col-xs-12 ach_main" [hidden]="!ShowACH">
        <div class="ach_main_left">
          <p>Total Gross Cash Discount Price if paying by ACH</p>
          <p>Agency Commission</p>
          <p>Total Net Cash Discount Price if paying by ACH</p>
          <p>Tax 1</p>
 <!--   new text change as per invocie PDF -->
          <!-- <p>Total Net Cash Discount Price if paying by ACH (Tax)</p> -->
          <p>Amount Due if paying by ACH</p>
        </div>
        <div class="ach_main_right" *ngIf="!isLoading">
          <p>${{invoiceDetail.invGrossAmountACH}}</p>
          <p>${{invoiceDetail.invAgencyamountACH}}</p>
          <p>${{invoiceDetail.invNetDiscountACH}}</p>
          <p>${{invoiceDetail.invTaxACH}}</p>
          <p>${{invoiceDetail.invTotalNetDiscountACH}}</p>
        </div>
        <div class="ach_details_loading" *ngIf="isLoading">
          <p-progressSpinner [style]="{width: '60px', height: '60px'}"></p-progressSpinner>
        </div>
        <div class="achbtn_main"><button type="button" [disabled]="InvalidAmount || InvalidAmount2 || isLoading" class="btn achbtn_modifi" (click)="Paynowprofile(1)">Click to Process</button></div>
      </div>
      <!-- <div class="col-lg-1 col-md-1 hidden-sm hidden-xs break_line">
      </div> -->
      <div class="col-lg-5 col-md-5 col-xs-12 ach_main" [hidden]="!ShowCC">
        <div class="ach_main_left">
          <p>Total Gross Regular Price if paying by credit card</p>
          <p>Agency Commission</p>
          <p>Total Net Regular Price if paying by credit card</p>
          <p>Tax 1</p>
          <!--   CHange for new text as per Invocie PDF -->
          <!-- <p>Total Net Regular Price if paying by credit card (Tax)</p> -->
          <p>Amount Due if paying by credit card</p> 
        </div>
        <div class="ach_main_right" *ngIf="!isLoading">
          <p>${{invoiceDetail.invGrossAmountCC}}</p>
          <p>${{invoiceDetail.invAgencyamountCC}}</p>
          <p>${{invoiceDetail.invNetDiscountCC}}</p>
          <p>${{invoiceDetail.invTaxCC}}</p>
          <p>${{invoiceDetail.invTotalNetDiscountCC}}</p>
        </div>
        <div class="cc_details_loading" *ngIf="isLoading">
          <p-progressSpinner [style]="{width: '60px', height: '60px'}"></p-progressSpinner>
        </div>
        <div class="achbtn_main"><button type="button" [disabled]="InvalidAmount || InvalidAmount2 || isLoading" class="btn achbtn_modifi" (click)="Paynowprofile(2)">Click to Process</button></div>
      </div>
      <div class="col-lg-12 col-md-12 col-xs-12">                  
            <button type="button" (click)="goback()" class="btn goback"><i class="fa fa-angle-left"></i> Back</button>                                
        </div>
    </div>        
  </div>
</main>
